import { sva } from '@allenai/varnish-panda-runtime/css';
import type { RecipeVariantProps } from '@allenai/varnish-panda-runtime/types';

const cardRecipe = sva({
    slots: ['root', 'header', 'body', 'footer', 'media'],
    base: {
        root: {
            border: '1px solid',
            backgroundColor: 'background.opacity-100',
            borderColor: 'stroke.opacity-10',
            borderRadius: '[4px]',
            display: 'grid',
            fontSize: '[17px]',
            gridTemplateRows: 'auto auto 1fr auto',
            gridTemplateAreas: `
                "header"
                "media"
                "body"
                "footer"
            `,
            gap: '[10px]',
            gridAutoColumns: '[minmax(200px, 1fr)]',
            maxWidth: '[100%]',
            overflow: 'hidden',
        },
        header: {
            color: 'text',
            padding: '[10px]',
            width: '[100%]',
            gridArea: 'header',
        },
        media: {
            color: 'text',
            width: '[100%]',
            gridArea: 'media',
        },
        body: {
            color: 'text',
            padding: '[10px]',
            width: '[100%]',
            gridArea: 'body',
        },
        footer: {
            color: 'text',
            padding: '[10px]',
            width: '[100%]',
            gridArea: 'footer',
        },
    },
});

type CardRecipeProps = RecipeVariantProps<typeof cardRecipe>;

export { cardRecipe, cardRecipe as default };
export type { CardRecipeProps };
